export default __webpack_public_path__ + "static/industry-412782457a52bf854471365b689c44ca.png";